import React from "react";
import { formatoDecimal } from "../../../utilities/formatoNumeros";
import TopSeller from "./TopSeller";
import TopTipoPublicaciones from "./TopTipoPublicaciones";
import Tab from "../../General/Tab";
import { normalizeTarjetasData } from "./DashboardHelper";

const tablaEstilo = {
  fondo: "#eaf3fa",
  header: "#f7d7b5",
  borde: "4px solid #f7d7b5",
};

const BadgeVar = ({ label, value, suffix = "%" }) => {
  const n = Number(value ?? 0);
  const isNeg = n < 0;
  return (
    <span
      className={`badge mx-1 ${isNeg ? "badge-danger" : "badge-success"}`}
      style={{ fontSize: 12 }}
      title={`${label}: ${n.toFixed(2)}${suffix}`}
    >
      {label}: {n.toFixed(2)}
      {suffix}
    </span>
  );
};

export default function TarjetasDashboard({
  data,
  onSelectProduct,
  tabProductos,
  setTabProductos,
  topSellers,
  tipoPublicaciones,
  userType,
  currentUserType // Add this
}) {
  const d = normalizeTarjetasData(data);
  // STRICT CHECK: 1 (Category) or 2 (AdminMod)
  const isFullAdmin = currentUserType == 1 || currentUserType == 2;
  const isAuthorizedSeller = !!(userType?.isSeller || userType?.isSellerAdmin);

  return (

    <>
      {/* KPIs */}
      <div className="row position-relative mb-4">
        {/* Ventas del Mes */}
        <div className="col-12 col-lg-3 mb-3">
          <div className="p-3 rounded shadow-sm h-100 dashboard-atributos text-center">
            <h6 className="text-muted mb-1">Total Ventas</h6>
            <h3 className="m-0">${formatoDecimal(`${d.ventasDelMes}`)}</h3>
            <div className="mt-2">
              <BadgeVar
                label="Var. mensual ventas"
                value={d.variacionMensualVentas}
              />
              <BadgeVar
                label="Var. anual ventas"
                value={d.variacionAnualVentas}
              />
            </div>
          </div>
        </div>

        {/* Comisión Ventas (OJO: acá estás mostrando ticketPromedio) */}
        <div className="col-12 col-lg-3 mb-3">
          <div className="p-3 rounded shadow-sm h-100 dashboard-atributos text-center">
            <h6 className="text-muted mb-1">Comisión Ventas</h6>
            <h3 className="m-0">${formatoDecimal(`${d.comisionVentas}`)}</h3>
          </div>
        </div>

        {/* Ticket Promedio */}
        <div className="col-12 col-lg-3 mb-3">
          <div className="p-3 rounded shadow-sm h-100 dashboard-atributos text-center">
            <h6 className="text-muted mb-1">Ticket Promedio</h6>
            <h3 className="m-0">${formatoDecimal(`${d.ticketPromedio}`)}</h3>
          </div>
        </div>

        {/* Unidades Vendidas */}
        <div className="col-12 col-lg-3 mb-3">
          <div className="p-3 rounded shadow-sm h-100 dashboard-atributos text-center">
            <h6 className="text-muted mb-1">Unidades Vendidas</h6>
            <h3 className="m-0">{d.unidadesVendidas}</h3>
            <div className="mt-2">
              <BadgeVar
                label="Var. mensual unidades"
                value={d.variacionMensualUnidades}
              />
              <BadgeVar
                label="Var. anual unidades"
                value={d.variacionAnualUnidades}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="col-12">
        <div className="p-3 rounded shadow-sm dashboard-container">
          <ul className="nav nav-tabs customtab mb-3" role="tablist">
            <div onClick={() => setTabProductos(0)}>
              <Tab
                name="Top Productos"
                icon="mdi mdi-trophy-variant-outline"
                isActive={tabProductos === 0}
              />
            </div>

            {/* Top Sellers (Solo Admin/Category?) */}
            {isFullAdmin && (
              <div onClick={() => setTabProductos(1)}>
                <Tab
                  name="Top Sellers"
                  icon="mdi mdi-account-group-outline"
                  isActive={tabProductos === 1}
                />
              </div>
            )}

            {/* Top Tipo Publicaciones (Admin + Seller) */}
            {(isFullAdmin || isAuthorizedSeller) && (
              <div onClick={() => setTabProductos(2)}>
                <Tab
                  name="Top Tipo Publicaciones"
                  icon="mdi mdi-format-list-bulleted-type"
                  isActive={tabProductos === 2}
                />
              </div>
            )}
          </ul>

          <div
            className="p-3 rounded shadow-sm dashboard-container"
            style={{ boxShadow: "none", border: "none" }}
          >
            {/* Top Productos */}
            {tabProductos === 0 && (
              <>
                <div className="d-flex align-items-center mb-2">
                  <i className="mdi mdi-trophy-variant-outline mx-2" />
                  <h5 className="m-0">Top productos</h5>
                </div>

                <div className="table-responsive mb-3">
                  <table className="table table-sm table-hover mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ minWidth: 120 }}>Código</th>
                        <th>Producto</th>
                        <th className="text-right" style={{ minWidth: 120 }}>
                          Unidades
                        </th>
                        <th className="text-right" style={{ minWidth: 160 }}>
                          Ventas
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {(d.topProductos || []).length > 0 ? (
                        d.topProductos.map((p, idx) => (
                          <tr
                            key={`${p.codigoProducto}-${idx}`}
                            role="button"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              onSelectProduct && onSelectProduct(p)
                            }
                            title="Buscar publicaciones por este código"
                          >
                            <td>{p.codigoProducto}</td>
                            <td>{p.nombreProducto}</td>
                            <td className="text-right">{p.unidadesVendidas}</td>
                            <td className="text-right">
                              ${formatoDecimal(`${p.montoVentas}`)}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center text-muted py-3">
                            Sin datos
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Top Sellers */}
            {isFullAdmin && tabProductos === 1 && (
              <>
                <div className="d-flex align-items-center mb-2">
                  <i className="mdi mdi-trophy-variant-outline mx-2" />
                  <h5 className="m-0">Top Sellers</h5>
                </div>
                <TopSeller sellers={topSellers} tablaEstilo={tablaEstilo} />
              </>
            )}

            {/* Top Tipo Publicaciones */}
            {(isFullAdmin || isAuthorizedSeller) && tabProductos === 2 && (
              <>
                <div className="d-flex align-items-center mb-2">
                  <i className="mdi mdi-trophy-variant-outline mx-2" />
                  <h5 className="m-0">Top Tipo Publicaciones</h5>
                </div>
                <TopTipoPublicaciones
                  tipos={tipoPublicaciones}
                  tablaEstilo={tablaEstilo}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
